import { siteApiSlice } from "../../../../app/siteApiSlice";
import { UsageFilteredByCourseViewModel } from "./UsageFilteredByCourseViewModel";
import { TutorialUsageByCourseAndFocusViewModel } from "./TutorialUsageByCourseAndFocusViewModel";
import { TutorialUsageByCourseAndTutorialViewModel } from "./TutorialUsageByCourseAndTutorialViewModel";

export const courseUsageReportApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		courseUsageReport: build.query<
			UsageFilteredByCourseViewModel,
			{ writerId?: number; courseId?: number }
		>({
			query: (arg) => {
				const { writerId, courseId } = arg;
				return {
					url: `/usage-report`,
					params: { writerId, courseId },
				};
			},
			providesTags: ["CurrentCourse"],
		}),
		tutorialUsageByCourseAndFocus: build.query<
			TutorialUsageByCourseAndFocusViewModel,
			{ focusId: number; courseId?: number }
		>({
			query: (arg) => {
				const { focusId, courseId } = arg;
				return {
					url: `/Report/TutorialUsageFilteredByCourseAndFocus`,
					params: { focusId, courseId },
				};
			},
			providesTags: ["CurrentCourse"],
		}),
		tutorialUsageByCourseAndTutorial: build.query<
			TutorialUsageByCourseAndTutorialViewModel,
			{ focusId: number; lessonId: number; courseId?: number }
		>({
			query: (arg) => {
				const { focusId, lessonId, courseId } = arg;
				return {
					url: `/Report/TutorialUsageFilteredByCourseAndFocusAndTutorial`,
					params: { focusId, lessonId, courseId },
				};
			},
			providesTags: ["CurrentCourse"],
		}),
	}),
});

export const {
	useCourseUsageReportQuery,
	useTutorialUsageByCourseAndFocusQuery,
	useTutorialUsageByCourseAndTutorialQuery,
} = courseUsageReportApiSlice;
